<div class="text-center d-inline" [innerHTML]="version"></div>
